import Vue from 'vue';
import { v1 as uuid } from 'uuid';
import SectionIncomplete from '@/modals/SectionIncomplete';

export const filerScreenHelpers = {
  components: {
  },
  data() {
    return {
      ready: false,
      prevRoute: null,
      itemUpdateId: null,
      tableAction: 'Add',
      newItemTemplate: {},
      hideMayorYear: 2021,
    };
  },
  computed: {
    showMayorForm () {
      let filingYear = this.filingYear || this.currentFiling.year;
      return parseInt(filingYear) < this.hideMayorYear;
    },
    allItems() {
      if (this.items) {
        return this.items.filter(item => {
          if (typeof item.cud !== 'undefined') {
            return item.cud !== 'delete';
          }
          return true;
        });
      }
      return this.items;
    },
    nextFilingScreen() {
      //except for the 2 routes below, all other routes should redirect to review-statements if the referer is review-statements
      if (this.prevRoute && this.prevRoute === 'review-statements' && this.$route.name !== 'submit-statements') {
        return 'review-statements';
      }

      //all else grabs the next route in the list
      return this.$store.getters['filings/getNextFilingScreen'](this.$route.name);

    },
  },
  created () {
    this.newItemTemplate = { ...this.newItem };
  },
  methods: {
    /**
    * @desc add a new item to array and mark it as api post
    */
    addNewItem() {
      this.items.push({ ...this.newItem, cud: 'post', id: uuid() });
      this.clearNewItemFields();
      this.tableAction = 'Add';
    },

    /**
    * @desc clears newItem fields after 'add' or 'update' action
    */
    clearNewItemFields() {
      this.newItem = { ...this.newItemTemplate };
    },
    /**
* @desc clones an existing item in the array
* @param { Int } id
*/
    cloneItem(id, skipProps) {
      //if item is a clone
      //copy it but change the id and mark as cloned
      let item = { ...this.items.find(item => item.id === id) };
      if (Array.isArray(skipProps)) {
        Object.keys(item).forEach(key => {
          skipProps.forEach(prop => {
            if (key === prop.key) {
              item[key] = prop.default;
            }
          });
        });
      }
      this.items.push({ ...item, cud: 'post', id: uuid(), cloned: true });
    },

    /**
    * @desc deletes array from array or mark item for deletion
    * @param { Int } id
    */
    deleteItem(id) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].id === id) {
          //If item was just added and then deleted
          //just remove item from array
          if (this.items[i].cud === 'post') {
            Vue.delete(this.items, i);
          } else {
            //If item was in db, but then is deleted
            //mark it for deletion
            Vue.set(this.items[i], 'cud', 'delete');
          }

        }
      }
      this.clearNewItemFields();
      this.tableAction = 'Add';
    },

    /**
    * @desc add items to newItem fields to be edited
    * @param { Int } id
    */
    editItem(id) {
      this.newItem = { ...this.items.find(item => item.id === id) };
      this.updateItemId = id;
      this.tableAction = 'Update';
    },

    getCurrentFiling() {
      if (this.$store.state.filing.filing) {
        //Checks to make sure we are editing a draft or that we are on the last screen
        if (this.$store.state.filing.filing.filingStatus === 'NF' || this.$store.state.filing.filing.filingStatus === 'AP' || this.$route.name === 'statements-submitted') {
          return this.cloneObj(this.$store.state.filing.filing);
        }
      }
    },

    /**
    * @desc updates an item in the array
    */
    updateItem() {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].id === this.updateItemId) {
          //No cud means it's an item from db that has not been edited
          //cud = post items are new, and should not be checked as cud = put
          //cud = delete items have been deleted, and should not be checked as cud = put
          if (!this.items[i].cud || (this.items[i].cud !== 'post' && this.items[i].cud !== 'delete')) {
            Vue.set(this.items, i, { ...this.newItem, cud: 'put' });
          } else {
            Vue.set(this.items, i, { ...this.newItem });
          }

          //Cloned items should always be cud = post
          if (this.items[i].cloned) {
            Vue.set(this.items, i, { ...this.newItem, cud: 'post' });
          }

          this.tableAction = 'Add';
          this.clearNewItemFields();
          break;
        }
      }
    },
    isDeletingAllItems() {
      return this.items.every(item => {
        return item.cud === 'delete';
      });
    },
    saveAndContinueCheck() {

      let isDeletingAll = this.isDeletingAllItems();

      if (this.nothingToReport === false && (this.items.length === 0 || isDeletingAll === true)) {
        this.$modal.show(
          SectionIncomplete,
          {
            pathName: this.nextFilingScreen,
          },
          {
            height: 'auto',
            scrollable: true,
            dynamic: true,
            adaptive: true,
            classes: [ 'is-small' ],
          },
        );
      } else {
        this.isSaving = true;
        this.saveAndContinue();
      }
    },
  },
};